import { useSnackbar } from '@/features/snackbar';
import { useFlag } from '@/features/unleash';
import { usePersistentStorage } from '@/hooks/useCoupon';
import { useLocale } from '@/hooks/useLocale';
import { useLocation } from '@/hooks/useLocation';
import { useTranslation } from '@/hooks/useTranslation';
import { useTypeformDrawer } from '@/hooks/useTypeformDrawer';
import routesGenerator from '@/router/routesGenerator';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { actionToPath } from 'redux-first-router';

const routesMap = routesGenerator();

export function I18nBetaNotification() {
  const flags = useFlag({ name: 'i18n-beta-notification' });
  const { enabled } = flags;
  const { addSnackbar, removeSnackbar } = useSnackbar();
  const t = useTranslation();
  const locale = useLocale();
  const location = useLocation();
  const { set, get } = usePersistentStorage();
  const { data, status } = useQuery({
    queryKey: ['i18n-beta-notification'],
    async queryFn() {
      const value = await get('i18n-beta-notification-status');
      return value === 'dismissed';
    },
  });
  const currentPath = actionToPath(location, routesMap);
  const makeFeedbackDrawer = useTypeformDrawer(
    locale === 'es' ? 'hhQKsh1e' : 'UjJqoRzy',
    {
      locale,
      canonical_url: currentPath,
    }
  );

  useEffect(() => {
    if (status === 'success' && !data && enabled && locale !== 'en') {
      addSnackbar({
        id: 'toast-i18n-beta-notification',
        message: t('notification.translationBeta'),
        type: 'warning',
        lifeTime: 7000,
        actionLabel: t('notification.translationBeta.action'),
        actionCallback() {
          makeFeedbackDrawer();
          /** Don't show again once they submit a feedback */
          set('i18n-beta-notification-status', 'dismissed');
          removeSnackbar({ id: 'toast-i18n-beta-notification' });
        },
        secondaryActionLabel: t('notification.translationBeta.secondaryAction'),
        secondaryActionCallback() {
          /** Don't show again once they dismiss */
          set('i18n-beta-notification-status', 'dismissed');
        },
      });
    } else {
      removeSnackbar({ id: 'toast-i18n-beta-notification' });
    }
  }, [data, status, set, makeFeedbackDrawer, enabled, locale]);
  return <></>;
}
